/** MUI 调色板配置 — 2026-10 翡翠绿主题（对齐 docs/后台UI 设计稿）
 *  主色取设计稿 emerald-deep #0F9D6F（白字对比度优于 #10B981），
 *  #10B981 / #34D399 作为渐变与强调色在 COLORS.primary.bright / accent 中使用。 */
import type { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#0F9D6F',
    dark: '#0B7A56',
    light: '#E7F8F1',
    contrastText: '#FFFFFF',
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7',
    400: '#34D399',
    500: '#10B981',
    600: '#0F9D6F',
    700: '#0B7A56',
    800: '#065F46',
    900: '#064E3B',
  },
  // 语义色（错误/警告/成功/信息）保持原值，仅品牌色切换为翡翠绿
  secondary: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E53935',
    light: '#FFEBEE',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FB8C00',
    light: '#FFF3E0',
    dark: '#E65100',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#00d4aa',
    light: '#E0F7F4',
    dark: '#00838F',
    contrastText: '#FFFFFF',
  },
  grey: {
    50: '#F7FAF8',
    100: '#EEF4F1',
    200: '#E3EAE6',
    300: '#D3DDD8',
    400: '#B7C3BC',
    500: '#8A9A92',
    600: '#6B7C74',
    700: '#4B5E55',
    800: '#33463D',
    900: '#10241D',
  },
  background: {
    default: '#F4F8F6',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#10241D',
    secondary: '#5B6B63',
    disabled: '#8A9A92',
  },
  divider: '#E3EAE6',
};
